import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications/dist/ToastProvider'
import hotelApi from 'services/api/hotel'

import styles from './UpdateLegalLinksDialog.module.scss'

const UpdateLegalLinksDialog = ({ onClose, privacyUrl, termsUrl, onSave }) => {
  const [privacy, setPrivacy] = useState(privacyUrl)
  const [terms, setTerms] = useState(termsUrl)

  const { addToast } = useToasts()

  function saveChanges() {
    hotelApi
      .updateAsUser({
        privacyUrl: privacy,
        termsUrl: terms
      })
      .then(() => {
        addToast('URLs are updated', { appearance: 'success' })
        onSave()
      })
      .catch(() => {
        addToast('Error updating URLs', { appearance: 'error' })
        onClose()
      })
  }

  return (
    <ConfirmationDialog
      onClose={onClose}
      title="Update terms and privacy links"
      onConfirm={saveChanges}
      positiveMessage="Save changes"
      maxWidth={800}
    >
      <div className={styles.container}>
        <div
          style={{ display: 'flex', flexDirection: 'column', width: 700, paddingTop: 10 }}
        >
          <TextInput label="Terms of Service" value={terms} onChangeValue={setTerms} />
          <TextInput label="Privacy Policy" value={privacy} onChangeValue={setPrivacy} />
        </div>
        <div></div>
      </div>
    </ConfirmationDialog>
  )
}

export default UpdateLegalLinksDialog
